import React, { useRef, useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { LayoutSplashScreen } from "../../../../_metronic/layout";
import * as auth from "./authRedux";
import { getUserByToken } from "./authCrud";
import { tokenStorage } from "../../../../_helpers/secureStorage";

function AuthInit(props) {
  const didRequest = useRef(false);
  const dispatch = useDispatch();
  const [showSplashScreen, setShowSplashScreen] = useState(true);

  // We should request user by accessToken before rendering the application
  useEffect(() => {
    const requestUser = async () => {
      try {
        if (!didRequest.current) {
          const { data: user } = await getUserByToken();

          const roleKey = user?.role?.key ? user.role.key.trim().toUpperCase() : (user?.role ? user.role.toString().toUpperCase() : "");
          const restrictedRoles = ["COUNTER", "AGENT", "USER", "STAFF"];

          if (restrictedRoles.includes(roleKey)) {
            alert("You are not authorized to login to this portal.");
            dispatch(props.logout());
            // Optional: alert or notification could be added here if possible, 
            // but logout will redirect to login page.
          } else {
            dispatch(props.fulfillUser(user));
          }
        }
      } catch (error) {
        if (!didRequest.current) {
          dispatch(props.logout());
        }
      } finally {
        setShowSplashScreen(false);
      }

      return () => (didRequest.current = true);
    };

    const authToken = tokenStorage.getAuthToken();

    if (authToken) {
      requestUser();
    } else {
      dispatch(props.fulfillUser(undefined));
      setShowSplashScreen(false);
    }
    // eslint-disable-next-line
  }, []);

  return showSplashScreen ? <LayoutSplashScreen /> : <>{props.children}</>;
}

export default connect(null, auth.actions)(AuthInit);
